
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createNote",
      resolverType: "mutation",
      routePath: "/createNote",
      httpMethod: "POST",
    });
  